import { useMemo } from 'react';
import { usePersonType } from './usePersonType';
export function useCanContractBenefits() {
    const { isPersonFisica, isPersonJuridica, isLoading } = usePersonType();
    return useMemo(() => ({
        canContract: isPersonJuridica && !isLoading,
        isPersonFisica,
        isPersonJuridica,
        isLoading,
    }), [isPersonFisica, isPersonJuridica, isLoading]);
}
